class Response {
  constructor(res) {
    this.code = res.code
    this.message = res.message
    this.data = res.data
    this.status = res.status
  }
}

export default Response
